import { database } from '@/plugins/firebase';
let seasonYear = '';
let loading = null;
async function read() {
    const doc = await database.collection('config').doc('season').get();
    const year = doc.data()?.year;
    if (!year) {
        throw new Error('Chybí konfigurace sezóny');
    }
    seasonYear = year;
}
/**
 * Read once, before anything reads a year-based collection - signing in and
 * restoring a session both wait for the same read. The server reads the same
 * document, so a tab that booted into another season is refused by every
 * callable until it reloads.
 */
export function loadSeasonYear() {
    if (!loading) {
        // A failed read must not stick: the next sign-in tries again.
        loading = read().catch((e) => {
            loading = null;
            throw e;
        });
    }
    return loading;
}
export function getSeasonYear() {
    return seasonYear;
}
export function seasonCollection(name) {
    return `${name}${seasonYear}`;
}
